package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AssetValuationQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    asset_id: String,
    date: String,
    value_: Long,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_320_669_542, arrayOf("asset_valuation"), driver, "AssetValuation.sq",
      "selectAll",
      "SELECT asset_valuation.id, asset_valuation.asset_id, asset_valuation.date, asset_valuation.value, asset_valuation.note, asset_valuation.created_at, asset_valuation.updated_at, asset_valuation.is_deleted, asset_valuation.deleted_at, asset_valuation.synced_at FROM asset_valuation WHERE is_deleted = 0 ORDER BY date DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectAll(): Query<Asset_valuation> = selectAll { id, asset_id, date, value_, note,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Asset_valuation(
      id,
      asset_id,
      date,
      value_,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByAsset(asset_id: String, mapper: (
    id: String,
    asset_id: String,
    date: String,
    value_: Long,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByAssetQuery(asset_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByAsset(asset_id: String): Query<Asset_valuation> = selectByAsset(asset_id) { id,
      asset_id_, date, value_, note, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Asset_valuation(
      id,
      asset_id_,
      date,
      value_,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    asset_id: String,
    date: String,
    value_: Long,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-2_145_386_869, arrayOf("asset_valuation"), driver, "AssetValuation.sq",
      "selectDirty",
      "SELECT asset_valuation.id, asset_valuation.asset_id, asset_valuation.date, asset_valuation.value, asset_valuation.note, asset_valuation.created_at, asset_valuation.updated_at, asset_valuation.is_deleted, asset_valuation.deleted_at, asset_valuation.synced_at FROM asset_valuation WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectDirty(): Query<Asset_valuation> = selectDirty { id, asset_id, date, value_, note,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Asset_valuation(
      id,
      asset_id,
      date,
      value_,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    asset_id: String,
    date: String,
    value_: Long,
    note: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Asset_valuation> = selectByIdAnyState(id) { id_,
      asset_id, date, value_, note, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Asset_valuation(
      id_,
      asset_id,
      date,
      value_,
      note,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    asset_id: String,
    date: String,
    value_: Long,
    note: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-732_815_548, """
        |INSERT INTO asset_valuation(id, asset_id, date, value, note, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, id)
          bindString(1, asset_id)
          bindString(2, date)
          bindLong(3, value_)
          bindString(4, note)
          bindLong(5, created_at)
          bindLong(6, updated_at)
        }
    notifyQueries(-732_815_548) { emit ->
      emit("asset_valuation")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_225_114_240,
        """UPDATE asset_valuation SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_225_114_240) { emit ->
      emit("asset_valuation")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-22_220_622,
        """UPDATE asset_valuation SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-22_220_622) { emit ->
      emit("asset_valuation")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-2_102_065_309,
        """UPDATE asset_valuation SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-2_102_065_309) { emit ->
      emit("asset_valuation")
    }
  }

  public fun update(
    asset_id: String,
    date: String,
    value_: Long,
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-387_869_356,
        """UPDATE asset_valuation SET asset_id = ?, date = ?, value = ?, note = ?, updated_at = ? WHERE id = ?""",
        6) {
          bindString(0, asset_id)
          bindString(1, date)
          bindLong(2, value_)
          bindString(3, note)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(-387_869_356) { emit ->
      emit("asset_valuation")
    }
  }

  private inner class SelectByAssetQuery<out T : Any>(
    public val asset_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("asset_valuation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("asset_valuation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_494_704_814,
        """SELECT asset_valuation.id, asset_valuation.asset_id, asset_valuation.date, asset_valuation.value, asset_valuation.note, asset_valuation.created_at, asset_valuation.updated_at, asset_valuation.is_deleted, asset_valuation.deleted_at, asset_valuation.synced_at FROM asset_valuation WHERE asset_id = ? AND is_deleted = 0 ORDER BY date DESC""",
        mapper, 1) {
      bindString(0, asset_id)
    }

    override fun toString(): String = "AssetValuation.sq:selectByAsset"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("asset_valuation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("asset_valuation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_888_833_310,
        """SELECT asset_valuation.id, asset_valuation.asset_id, asset_valuation.date, asset_valuation.value, asset_valuation.note, asset_valuation.created_at, asset_valuation.updated_at, asset_valuation.is_deleted, asset_valuation.deleted_at, asset_valuation.synced_at FROM asset_valuation WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "AssetValuation.sq:selectByIdAnyState"
  }
}
